import {
  QCard,
  QCardSection,
  QCardActions,
  QToolbar,
  QToolbarTitle,
  QToggle,
  QSeparator,
  QInput,
  QBtn,
  QTable,
  QTr,
  QTd,
  QTooltip,
  QBtnDropdown,
  QChip,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QMarkupTable,
  QTab,
  QTabs,
  QTabPanel,
  QTabPanels,
  QBtnGroup,
  QSelect,
  QSpace,
  QSpinner,
  QExpansionItem,
} from 'quasar';

export default {
  QCard,
  QCardSection,
  QCardActions,
  QToolbar,
  QToolbarTitle,
  QToggle,
  QSeparator,
  QInput,
  QBtn,
  QTable,
  QTr,
  QTd,
  QTooltip,
  QBtnDropdown,
  QChip,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QMarkupTable,
  QTab,
  QTabs,
  QTabPanel,
  QTabPanels,
  QBtnGroup,
  QSelect,
  QSpace,
  QSpinner,
  QExpansionItem,
};
